define(
  'CommerceCategoriesTitles.EntryPoint',
  [
    'Facets.Browse.View',
    'underscore'
  ],
  function (

    FacetsBrowseView,
    _
  ) {
    'use strict';

    function getUrlInfo() {
      if (window.location.hash) {
        var url = window.location.hash;
        url = url.replace('#', '/');
        return url;
      }
      return window.location.pathname;

    }

    return {
      mountToApp: function mountToApp(container) {

        var self = this;
        self.environment = container.getComponent('Environment');
        self.config = self.environment.getConfig('CommerceCategoryTitle');

        _.extend(FacetsBrowseView.prototype, {
          getContext: _.wrap(FacetsBrowseView.prototype.getContext, function (fn) {
            var ctx = fn.apply(this, _.toArray(arguments).slice(1));

            var titleConfig = _.findWhere(self.config, {'url': getUrlInfo()});
            if (!_.isEmpty(titleConfig)) {
              ctx.subcategoriesHeading = titleConfig.commerceCategoryTitle;
            }
            return ctx;
          })
        });
      }
    };
  });
